import { render, staticRenderFns } from "./termsandconditions.vue?vue&type=template&id=0b675004&scoped=true&"
import script from "./termsandconditions.vue?vue&type=script&lang=js&"
export * from "./termsandconditions.vue?vue&type=script&lang=js&"
import style0 from "./termsandconditions.vue?vue&type=style&index=0&id=0b675004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b675004",
  null
  
)

export default component.exports